// The rooms this player made or joined: the code, who was in it, and what
// they scored in each game played there. Plus one-off challenges.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getMyRooms } from '../../services/authService';
import { GAME_INFO } from '../../services/playHistory';
import './ProfileRooms.css';

const MAX = { character: 15, image: 15, devilfruit: 15, bounty: 11 };
const day = (t) => new Date(t).toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
const clock = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;

const Result = ({ g }) => (
  <span className="pr-game">
    <span className="pr-game-name">{(GAME_INFO[g.game] || {}).name || g.game}</span>
    <span className="pr-game-score">
      {g.score == null ? 'not played' : `${g.score}/${g.rounds || MAX[g.game] || 15}${g.time ? ` · ${clock(g.time)}` : ''}`}
    </span>
    <span className="pr-game-players">{g.players} {Number(g.players) === 1 ? 'player' : 'players'}</span>
  </span>
);

export default function ProfileRooms() {
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    getMyRooms().then((r) => { if (alive) setData(r && r.success ? r : { rooms: [], challenges: [] }); });
    return () => { alive = false; };
  }, []);

  return (
    <div className="pr">
      <h2 className="stats-title">Your Rooms</h2>
      {!data ? <p className="pr-empty">Loading…</p> : null}
      {data && !data.rooms.length && !data.challenges.length && (
        <p className="pr-empty">No rooms yet. Make one from any game and send the link to your crew.</p>
      )}
      {data && data.rooms.map((r) => (
        <Link key={r.code} to={`/room/${r.code}`} className="pr-room">
          <div className="pr-room-top">
            <span className="pr-room-name">{r.name || 'Room'}</span>
            <span className="pr-code">{r.code}</span>
          </div>
          <div className="pr-room-meta">{day(r.created_at)} · made by {r.created_by || '—'}</div>
          {r.members.length > 0 && (
            <div className="pr-members">{r.members.map((m, i) => <span key={`${m}-${i}`} className="pr-member">{m}</span>)}</div>
          )}
          {r.games.length > 0 && <div className="pr-games">{r.games.map((g, i) => <Result key={i} g={g} />)}</div>}
        </Link>
      ))}
      {data && data.challenges.length > 0 && (
        <>
          <h3 className="pr-sub">Challenges</h3>
          {data.challenges.map((c) => (
            <div key={c.code} className="pr-room pr-challenge">
              <div className="pr-room-top">
                <span className="pr-room-name">from {c.created_by || 'a friend'}</span>
                <span className="pr-code">{c.code}</span>
              </div>
              <div className="pr-room-meta">{day(c.created_at)}</div>
              <div className="pr-games"><Result g={c} /></div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
